import { LocationType } from '../../models/enum/locationtype';

export class Location {
  type: LocationType;
  countryICAO: string;
  countryDescription: string;
  locationICAO: string;
  locationDescription: string;
}
